import * as MuiIcons from '@mui/icons-material';
import { MdFiberNew } from 'react-icons/md';

// Common menu item properties
const commonMenuProps = {
  Settings: {
    key: 'Settings',
    name: 'Settings',
    icon: <MuiIcons.SettingsOutlined />,
    path: '/settings',
  },
  Home: (path = '/') => ({
    key: 'Home',
    name: 'My Dashboard',
    icon: <MuiIcons.HomeOutlined />,
    path,
  }),
};

// Define consistent styling
// const peopleIconStyle = { color: 'var(--clr-theme-white)' };

export const LeftMenu = [
  commonMenuProps.Home(),
  {
    key: 'Patient List',
    name: 'Patient List',
    icon: <MuiIcons.PeopleOutlined sx={{ color: 'var(--clr-theme-gray)' }} />,
    collapsible: true,
  },
  {
    key: 'Appointments',
    name: 'Appointments',
    icon: <MuiIcons.CalendarMonthOutlined />,
    path: '/appointments',
  },
  {
    key: 'Goals',
    name: 'Goals',
    icon: <MuiIcons.TrackChangesOutlined />,
    path: '/viewgoals',
    collapsible: true,
    submenu: [
      {
        key: 'Goals Overview',
        name: 'Goals Overview',
        icon: <MuiIcons.FlagRounded sx={{ color: 'black' }} />,
        path: '/allgoals',
      },

      {
        key: 'QuickTrackDashboard',
        name: 'QuickTrack Dashboard',
        icon: <MuiIcons.Psychology sx={{ color: 'black' }} />,
        path: '/quicktrackDashboard',
      },
      {
        key: 'Pending Goals',
        name: 'Pending Goals & QuickTracks',
        icon: <MuiIcons.TrackChanges sx={{ color: 'black' }} />,
        path: '/pendinggoals',
      },
    ],
  },
  // {
  //   key: 'Statistics',
  //   name: 'Statistics',
  //   icon: <MuiIcons.QueryStatsOutlined />,
  //   path: '/statistics',
  // },
  {
    key: 'Videos',
    name: 'Videos',
    icon: <MuiIcons.Videocam />,
    path: '/viewallvideos',
  },
  {
    key: 'HistoricalData',
    name: 'Historical Data',
    icon: <MuiIcons.MenuBookOutlined />,
    path: '/historical',
  },
  {
    key: 'Messaging',
    name: 'Messaging',
    icon: <MuiIcons.Message />,
    additionalIcon: <MdFiberNew />,
    path: '/message',
  },
  commonMenuProps.Settings,
];

export const SchoolAdminLeftMenu = [
  commonMenuProps.Home('/schoolAdmin'),
  {
    key: 'Schools List',
    name: 'Schools List',
    icon: <MuiIcons.AddHomeWorkOutlined />,
    // collapsible: true,
    path: '/schools',
  },
  {
    key: 'Teacher List',
    name: 'Teacher List',
    icon: <MuiIcons.BusinessCenterOutlined />,
    // collapsible: true,
    path: '/teachers',
  },
  {
    key: 'Student List',
    name: 'Student List',
    icon: <MuiIcons.SchoolOutlined />,
    // collapsible: true,
    path: '/students',
  },
  {
    key: 'Permissions',
    name: 'Subroles',
    icon: <MuiIcons.Lock />,
    path: '/subroles',
  },
  commonMenuProps.Settings,
];

export const AdminLeftMenu = [
  {
    key: 'Home',
    name: 'Dashboard',
    icon: <MuiIcons.HomeOutlined />,
    path: '/admin',
  },
  {
    key: 'Schools',
    name: 'Schools',
    icon: <MuiIcons.AddHomeWorkOutlined />,
    path: '/admin/schools',
  },
  {
    key: 'Organization Admin',
    name: 'Organization Admin',
    icon: <MuiIcons.ManageAccountsOutlined />,
    path: '/admin/organization',
  },
  {
    key: 'School Admin',
    name: 'School Admin',
    icon: <MuiIcons.AccountBoxOutlined />,
    path: '/admin/schoolsAdmin',
  },
  // {
  //   key: 'Teachers',
  //   name: 'Teachers',
  //   icon: <MuiIcons.BusinessCenterOutlined />,
  //   path: '/admin/teachers',
  // },
  // {
  //   key: 'Students',
  //   name: 'Students',
  //   icon: <MuiIcons.SchoolOutlined />,
  //   path: '/admin/students',
  // },
  {
    key: 'Permissions',
    name: 'Permissions',
    icon: <MuiIcons.Lock />,
    path: '/admin/permissions',
  },
  {
    key: 'Terms and Policies',
    name: 'Terms and Policies',
    icon: <MuiIcons.GavelOutlined />,
    path: '/admin/terms',
  },
  {
    key: 'Billing Management',
    name: 'Billing Management',
    icon: <MuiIcons.AccountBalance />,
    path: '/admin/billing',
    collapsible: true,
    submenu: [
      {
        key: 'Billing Overview',
        name: 'Billing Overview',
        icon: <MuiIcons.Dashboard sx={{ color: 'black' }} />,
        path: '/admin/billing',
      },
      {
        key: 'Plan Management',
        name: 'Plan Management',
        icon: <MuiIcons.Assignment sx={{ color: 'black' }} />,
        path: '/admin/billing?tab=1',
      },
    ],
  },
];

export const TeacherLeftMenu = [
  {
    key: 'Home',
    name: 'Dashboard',
    icon: <MuiIcons.HomeOutlined />,
    path: '/teacher',
  },
  {
    key: 'Student List',
    name: 'Student List',
    icon: <MuiIcons.PeopleOutlined sx={{ color: 'black' }} />,
    collapsible: true,
  },
  {
    key: 'Appointments',
    name: 'Appointments',
    icon: <MuiIcons.CalendarMonthOutlined />,
    path: '/appointments',
  },
  {
    key: 'Goals',
    name: 'Goals',
    icon: <MuiIcons.TrackChangesOutlined />,
    path: '/viewgoals',
    collapsible: true,
    submenu: [
      {
        key: 'Goals Overview',
        name: 'Goals Overview',
        icon: <MuiIcons.FlagRounded sx={{ color: 'black' }} />,
        path: '/allgoals',
      },
    ],
  },
  // {
  //   key: 'Statistics',
  //   name: 'Statistics',
  //   icon: <MuiIcons.QueryStatsOutlined />,
  //   path: '/statistics',
  // },
  {
    key: 'HistoricalData',
    name: 'Historical Data',
    icon: <MuiIcons.MenuBookOutlined />,
    path: '/historical',
  },
  {
    key: 'Messaging',
    name: 'Messaging',
    icon: <MuiIcons.Message />,
    additionalIcon: <MdFiberNew />,
    path: '/message',
  },
  commonMenuProps.Settings,
];

export const LeftMenu_BottomSection = [
  {
    key: 'Privacy',
    name: 'Privacy Statement',
    icon: <MuiIcons.PrivacyTip fontSize='small' />,
    path: '/Privacy',
  },
  {
    key: 'Termcondition',
    name: 'Terms and Conditions',
    icon: <MuiIcons.BrandingWatermark fontSize='small' />,
    path: '/Termcondition',
  },
  {
    key: 'Contact',
    name: 'Contact Information',
    icon: <MuiIcons.ContactPhone fontSize='small' />,
    path: '/Contact',
  },
];

export const StudentPatientLeftMenu = [
  commonMenuProps.Home(),
  {
    key: 'Appointments',
    name: 'Appointments',
    icon: <MuiIcons.CalendarMonthOutlined />,
    path: '/appointments',
  },
  {
    key: 'Goals',
    name: 'Goals',
    icon: <MuiIcons.TrackChangesOutlined />,
    path: '/viewgoals',
    collapsible: true,
    submenu: [
      {
        key: 'Goals Overview',
        name: 'Goals Overview',
        icon: <MuiIcons.FlagRounded sx={{ color: 'black' }} />,
        path: '/allgoals',
      },
      {
        key: 'QuickTrackDashboard',
        name: 'QuickTrack Dashboard',
        icon: <MuiIcons.Psychology sx={{ color: 'black' }} />,
        path: '/quicktrackDashboard',
      },
      {
        key: 'Pending Goals',
        name: 'Pending Goals',
        icon: <MuiIcons.TrackChanges sx={{ color: 'black' }} />,
        path: '/pendinggoals',
      },
    ],
  },
  // {
  //   key: 'Statistics',
  //   name: 'Statistics',
  //   icon: <MuiIcons.QueryStatsOutlined />,
  //   path: '/statistics',
  // },
  {
    key: 'HistoricalData',
    name: 'Historical Data',
    icon: <MuiIcons.MenuBookOutlined />,
    path: '/historical',
  },
  {
    key: 'Videos',
    name: 'Videos',
    icon: <MuiIcons.Videocam />,
    path: '/viewallpatientvideos',
  },
  {
    key: 'Messaging',
    name: 'Messaging',
    icon: <MuiIcons.Message />,
    additionalIcon: <MdFiberNew />,
    path: '/message',
  },
  commonMenuProps.Settings,
];

export const OrgAdminLeftMenu = [
  {
    key: 'Home',
    name: 'Dashboard',
    icon: <MuiIcons.HomeOutlined />,
    path: '/organizationAdmin',
  },
  {
    key: 'Schools',
    name: 'Schools',
    icon: <MuiIcons.AddHomeWorkOutlined />,
    path: 'orgschools',
  },
  {
    key: 'School Admins',
    name: 'School Admins',
    icon: <MuiIcons.AccountBoxOutlined />,
    path: '/organizationSchoolAdmins',
  },
  {
    key: 'Students',
    name: 'Students',
    icon: <MuiIcons.SchoolOutlined />,
    path: '/organizationStudents',
  },
  {
    key: 'Teachers',
    name: ' Teachers',
    icon: <MuiIcons.BusinessCenterOutlined />,
    path: '/organizationTeachers',
  },
  {
    key: 'Permissions',
    name: 'Permissions',
    icon: <MuiIcons.Lock />,
    path: '/permissions',
  },
  commonMenuProps.Settings,
];

export const DRAWER_WIDTH = 297;
